//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import sanitizeHtml from 'sanitize-html';
import MessageDialog from '../violation/message-dialog.vue';
import addLinkDialog from '../add-link-dialog.vue';
import * as api from '~/api/index';
import * as types from '~/types';
import { formatCommit } from '~/utils/index.js';
import { GetUserFollowPortfolioList } from '~/api/portfolio';
import { getStockV2 } from '~/api';
import ImageViewer from '~/components/public/image-viewer.vue';
import { GetAvailableTags, UploadFile } from '@/api/moments';
import { FILE_ICONS } from '@/constants/index';
export default {
  components: {
    MessageDialog,
    addLinkDialog,
    ElImageViewer: ImageViewer,
  },
  props: {
    showPostSubmitBtn: {
      type: Boolean,
      default: false,
    },
    className: {
      // 类名 同一个页面不止出现一次当前组件的时候需要传类名
      type: String,
      default: 'comment',
    },
    shareObj: {
      // 分享的数据
      type: Object,
      default() {
        return null;
      },
    },
    replyId: {
      // 回复的动态id
      default: null,
    },
    replyCommentId: {
      // 回复的评论id
      default: null,
    },
    defaultContent: {
      // 输入框默认显示内容
      type: String,
      default: '',
    },
    closeComment: {
      // 是否关闭评论
      type: Boolean,
      default: false,
    },
    avatarUrl: {
      // 头像url
      type: String,
      default: '',
    },
    hiddenBtns: {
      // 隐藏指定按钮 链接:link 图片:img 股票:stock 用户:user 话题:topic 取消按钮:cancel 发表按钮submit
      type: Array,
      default() {
        return [];
      },
    },
    hideFooter: {
      // 隐藏所有按钮
      type: Boolean,
      default: false,
    },
    isCollapse: {
      // 输入框是否收起
      type: Boolean,
      default: false,
    },
    imageLimit: {
      // 添加图片的数量限制
      type: Number,
      default: 1,
    },
    showTitle: {
      // 输入框是否可输入标题
      type: Boolean,
      default: false,
    },
    contenteditable: {
      // 输入框是否可编辑
      type: Boolean,
      default: true,
    },
    reviewStatus: {
      // reviewStatus是否审核通过，审核失败不能评论或者分享 approved:审核通过 rejected:审核不通过 pending:暂未审核
      type: String,
      default: 'approved',
    },
    autoFocus: {
      // 光标对焦 start：光标处于最前面 end：光标处于最后 ''默认不出现光标
      type: String,
      default: '',
    },
    confirmBtnText: {
      // 发表按钮的文案
      type: String,
      default: '发讨论',
    },
    hasBtnText: {
      // 是否显示操作按钮文字, 默认显示
      type: Boolean,
      default: true,
    },
    height: {
      // 输入框高度
      type: Number,
      default: 100,
    },
    collapseHeight: {
      // 输入框收起后的高度
      type: Number,
      default: 45,
    },
    bgColor: {
      // 当前组件背景色
      type: String,
      default: '#f6f6f6',
    },
    inputBgColor: {
      // 输入框背景色
      type: String,
      default: '#fff',
    },
    confirmBtnColor: {
      // 发表按钮不可点击时的颜色
      type: String,
      default: '#bbb',
    },
    activeConfirmBtnColor: {
      // 发表可点击时的颜色
      type: String,
      default: '#386ff2',
    },
    // 圈子信息
    momentInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    showMomentInfo: {
      type: Boolean,
      default: false,
    },
    // 是否展示可匿名
    isAnonymousQuestionEnabled: {
      type: Boolean,
      default: false,
    },
    moduleType: {
      type: String,
      default: 'community',
    },
    // 默认输入框文案
    placeholder: {
      type: String,
      default: '说说你的看法',
    },
    isDropUpload: {
      type: Boolean,
      default: false,
    },
    isPasteUpload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timeTimeout: null, // 搜索时间
      sendTime: null, // 发送时间
      inputTime: null, // 输入时间
      searchKeyword: '', // 搜索关键字
      selectOptions: [], // 待选列表
      searchType: '', // 搜索类型  stock:股票或组合  user:用户  link:链接
      searchName: '',
      searchShow: false,
      picList: [], // 图片列表
      addLinkShow: false, // 是否显示添加链接弹窗
      messageData: {
        show: false, // 是否显示温馨提示
        content: '该内容已限制评论', // 温馨提示内容
      },
      topic: {
        topicId: null, // 选中的主题
        topicName: '',
      },
      collapse: false, // 是否收起
      canConfirm: false, // 能否提交
      dynamicTitle: '', // 动态标题
      isCheck: false, // 是否转发至社区
      showViewer: false,
      previewSrcList: [],
      fileList: [], // 文件列表
      showTagChoose: false, // 显示标签选择
      optionalTags: [], // 可用的标签
      defaultTags: [], // 默认的标签
      momentTags: [], // 选中的标签
      confirmedMomentTags: [], // 确定的标签
      fileUploadedArray: [], // 已上传的文件
      videoUploadedArray: [], // 已上传的视频
      questionAnonymity: false, // 是否匿名回答
      uploadProgress: 0, // 上传进度
      uploadName: '', // 正在上传的文件名
      uploading: false, // 正在上传中
      dragover: false,
    };
  },
  computed: {
    ...mapGetters('user', ['isLogin', 'userId']),
    uploadImgRef() {
      return `doUploadImg${this.className}`;
    },
    uploadFileRef() {
      return `doUploadFile_${this.className}`;
    },
    uploadVideoRef() {
      return `doUploadVideo_${this.className}`;
    },
    confirmedMomentTagsText() {
      return this.confirmedMomentTags.map(item => item.tagName).join('、');
    },
    momentId() {
      return this.momentInfo?.momentId || '';
    },
    // 可用上传 img / file / video
    avalibleExtroType() {
      if (
        this.fileUploadedArray.length === 0 &&
        this.videoUploadedArray.length === 0 &&
        this.picList.length
      )
        return '';
      if (this.fileUploadedArray.length > 0) return 'file';
      if (this.videoUploadedArray.length > 0) return 'video';
      if (this.picList.length > 0) return 'img';
      return '';
    },
    showUploadProgress() {
      return (
        (this.uploadProgress > 0 && this.uploadProgress < 100) || this.uploading
      );
    },
  },
  watch: {
    searchKeyword: {
      handler() {
        clearTimeout(this.timeTimeout);
        this.timeTimeout = setTimeout(() => {
          this.searchList();
        }, 500);
      },
    },
    picList: {
      handler() {
        this.changeCanConfirm();
      },
    },
    defaultContent() {
      this.showDefaultContent();
    },
    fileUploadedArray: {
      handler() {
        this.changeCanConfirm();
      },
    },
  },
  mounted() {
    this.collapse = this.isCollapse;
    this.showDefaultContent();
  },
  methods: {
    ...mapMutations('user', {
      show: types.SHOW_LOGIN_FORM,
    }),
    /**
     * @description 输入框显示默认内容
     */
    showDefaultContent() {
      this.$nextTick(() => {
        const contentBox = document.querySelector(
          '.input-box' + this.className
        );
        if (!contentBox) return false;
        contentBox.innerHTML = this.defaultContent
          ? formatCommit(this.defaultContent) + '&nbsp;'
          : '';
        if (contentBox.innerHTML || this.shareObj) {
          this.canConfirm = true; // 已经有默认内容/分享，按钮状态设置为可提交
        }
        // 光标自动对焦
        const sel = window.getSelection();
        switch (this.autoFocus) {
          case 'start':
            sel.selectAllChildren(contentBox);
            sel.collapseToStart();
            break;
          case 'end':
            sel.selectAllChildren(contentBox);
            sel.collapseToEnd();
            break;
          default:
            break;
        }
      });
    },
    /**
     * @description 格式化转发内容
     * @returns { string } 格式化文案
     */
    formatText(content) {
      let text = '';
      if (this.shareObj.authorNick) {
        text = `<span class="share-nick">${this.shareObj.authorNick}：</span>`;
      }
      text += formatCommit(content);
      return text;
    },
    /**
     * @description 点击添加链接
     */
    addLinkByBtn() {
      this.searchType = 'link';
      this.addSelectedHold();
      this.addLinkShow = true;
    },
    /**
     * @description 取消添加链接
     */
    cancelAddLink() {
      this.addLinkShow = false;
      const holdDom = document.querySelector(`.hold${this.className}`);
      if (holdDom) holdDom.parentNode.removeChild(holdDom);
    },
    /**
     * @description 确定添加链接
     */
    confirmAddLink(info) {
      this.chooseStockOrUser(info);
      this.addLinkShow = false;
      this.searchType = '';
    },
    fakeUpload(refKey) {
      if (!this.isLogin) {
        this.show(false);
        return;
      }
      this.$refs[this[refKey]].click();
    },
    async handleImg() {
      const file = document.querySelector(`#${this.uploadImgRef}`).files[0];
      if (!file) return false; // 防止--在至少上传过一次图片后，再次上传时点击取消是跳500页面
      await this.uploadImg(file);
      document.querySelector(`#${this.uploadImgRef}`).value = '';
    },
    /**
     * @description 上传图片
     */
    async uploadImg(file) {
      if (this.picList.length >= this.imageLimit) {
        this.messageData.show = true;
        this.messageData.content = `不能超过${this.imageLimit}张图片`;
        return false;
      }
      if (!/(jpg|jpeg|png|gif){1}/gi.test(file.type)) {
        this.messageData.show = true;
        this.messageData.content = '仅支持.jpg .jpeg .png .gif的图片格式';
        return false;
      }
      if (file.size > 3000000) {
        this.messageData.show = true;
        this.messageData.content = '图片大小超过最大限制';
        return false;
      }
      const fileData = new FormData();
      fileData.append('file', file, file.name);
      fileData.append('module', this.moduleType);
      const res = await this.$axios(api.uploadActivityImageV2(fileData));
      if (res.result) {
        this.picList.push({
          imgurl: res.result,
        });
      } else if (res.statusCode === 403 && res.message) {
        this.messageData.show = true;
        this.messageData.content = res.message;
      }
    },
    async handleFile(key) {
      const files = document.querySelector(`#${key}`)?.files;
      await this.upload(files, key);
      document.querySelector(`#${key}`).value = '';
    },
    /**
     *  @description 上传
     */
    async upload(files, type) {
      const len = files?.length || 0;
      if (len > 0 === false) return;
      const Count =
        (this.videoUploadedArray.length || this.fileUploadedArray.length) + len;
      if (Count > 10) {
        this.messageData.show = true;
        this.messageData.content = '上传数量限制10个';
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const fileData = new FormData();
        const f = files[i];
        const n = f.name;
        fileData.append('file', f, n);
        this.uploadProgress = 1;
        this.uploadName = n;
        this.uploading = true;
        const data = await this.$axios(
          UploadFile(fileData, this.onUploadProgress)
        );
        const r = data?.result;
        this.uploading = false;
        this.uploadProgress = 0;
        this.uploadName = '';
        if (!r) {
          this.messageData.show = true;
          this.messageData.content = data.message;
          break;
        }
        r.icon = FILE_ICONS[r.extension] || FILE_ICONS['unknown'];
        if (!type || type.includes('File')) {
          this.fileUploadedArray.push(r);
        } else if (type.includes('Video')) {
          this.videoUploadedArray.push(r);
        }
      }
    },
    // 上传进度条展示
    onUploadProgress(progressEvent) {
      const complete = Math.ceil(
        (progressEvent.loaded / progressEvent.total) * 100 || 0
      );
      this.uploadProgress = complete;
    },
    // 上传进度文字内容
    onUploadFormat(percent) {
      return `(${this.uploadName}) - ${percent}%`;
    },
    /**
     * @description 删除图片
     */
    deletePic(idx) {
      this.picList.splice(idx, 1);
    },
    deleteFile(idx) {
      this.fileUploadedArray.splice(idx, 1);
    },
    deleteVideo(idx) {
      this.videoUploadedArray.splice(idx, 1);
    },
    /**
     * @description 定位搜索框
     */
    showSearchSelectedBox(type, searchName) {
      this.searchType = type;
      this.addSelectedHold();
      this.searchName = searchName;
      this.searchShow = !this.searchShow;
      if (!this.searchShow) return;
      this.$nextTick(() => {
        const hold = document.querySelector(`.${type}-btn-${this.className}`);
        const inputDom = document.querySelector('.comment-search-box');
        const right = hold.parentNode.offsetWidth - hold.offsetLeft - 230; // 搜索框的宽度230px
        const top = hold.offsetTop;
        // 设置搜索框位置
        inputDom.style.right = right < 0 ? '0' : right + 'px';
        inputDom.style.top = top + 20 + 'px';
        document.querySelector('.comment-search-box__search-input').focus();
      });
      if (this.searchType === 'stock') {
        this.getFollowPortfolioList();
      }
    },
    /**
     * @description 遮罩层处理
     */
    hideStockOrUserByBtn() {
      if (this.searchShow) {
        this.searchShow = false;
        this.searchKeyword = '';
      } else {
        this.collapse = true;
      }
      this.searchType = '';
      this.selectOptions = [];
      const holdDom = document.querySelector(`.hold${this.className}`);
      if (holdDom) holdDom.parentNode.removeChild(holdDom);
    },
    /**
     * @description 搜索相关列表
     */
    async searchList() {
      // portfolio组合
      if (!this.searchKeyword) {
        this.getFollowPortfolioList();
        return false;
      }
      if (this.searchType === 'topic') {
        const res = await this.$axios(
          api.searchTopicList({
            keyword: this.searchKeyword,
            page: 1,
            limit: 10,
          })
        );
        this.selectOptions = res.result || [];
      } else {
        const res = await this.$axios(
          api.searchAllThings({
            searchType: this.searchType,
            keyword: this.searchKeyword,
            count: 10,
            page: 1,
          })
        );
        if (this.searchType === 'stock') {
          this.selectOptions = (res.result && res.result.stockList) || [];
          this.getPortfolioInfo();
        } else {
          this.selectOptions = (res.result && res.result.userList) || [];
        }
      }
    },
    /**
     * @description 搜索组合
     */
    async getPortfolioInfo() {
      const res = await this.$axios(
        getStockV2({
          keyword: this.searchKeyword,
          page: 1,
          count: 10,
        })
      );
      if (res.result) {
        const stockList = res.result.stockList || [];
        const formatList = stockList.map(item => {
          return {
            id: item.id,
            stockCode: item.code,
            stockCodeDisp: item.codeDisp,
            ipoStatus: item.ipoStatus,
            type: item.market,
            stockName: item.name,
            stockNameDisp: item.nameDisp,
            stockCategory: item.category,
          };
        });
        this.selectOptions.push(...formatList);
      }
    },
    /**
     * @description 默认显示我关注的组合列表
     */
    async getFollowPortfolioList() {
      const res = await this.$axios(GetUserFollowPortfolioList(this.userId));
      this.selectOptions = res.result || [];
    },
    /**
     * @description 添加指定标签
     */
    addSelectedHold() {
      const sel = window.getSelection();
      let range;
      const html = `<span class="hold${this.className}">${
        this.searchType === 'link' ? '<i class="iconfont">&#xe615;</i>' : ''
      }</span>`;
      const contentBox = document.querySelector(`.input-box${this.className}`);
      if (
        (sel.anchorNode &&
          sel.anchorNode.className !== contentBox.className &&
          sel.anchorNode.parentElement.className !== contentBox.className &&
          sel.anchorNode.parentElement.parentElement.className !==
            contentBox.className) ||
        !sel.anchorNode
      ) {
        // 不在焦点的情况点击
        sel.selectAllChildren(contentBox);
        sel.collapseToEnd();
      }
      if (sel.getRangeAt && sel.rangeCount) {
        range = sel.getRangeAt(0);
        range.deleteContents();
        const el = document.createElement('div');
        el.innerHTML = html;
        const frag = document.createDocumentFragment();
        frag.appendChild(el.firstChild);
        const firstNode = frag.firstChild;
        range.insertNode(frag);
        if (firstNode) {
          range = range.cloneRange();
          // range.setStart(firstNode, 1);
          if (this.searchType !== 'link') {
            range.setStart(firstNode, 0);
          } else {
            range.setStart(firstNode, 1);
            range.collapse(true);
          }
          sel.removeAllRanges();
          sel.addRange(range);
        }
      }
    },
    /**
     * @description 输入框添加 链接标签 ｜ 股票标签 ｜ 用户标签
     */
    chooseStockOrUser(opt = {}) {
      if (this.searchType === 'topic') {
        this.topic.topicId = opt.topicId;
        this.topic.topicName = opt.topicName;
        return;
      }
      const holdDom = document.querySelector(`.hold${this.className}`);
      if (!holdDom) {
        this.addSelectedHold();
        this.chooseStockOrUser(opt);
        return;
      }
      const parentDom = holdDom.parentNode;
      const newDom = document.createElement('a');
      newDom.contentEditable = false;
      newDom.innerHTML = this.addLinkShow
        ? `<i class="iconfont">&#xe615;</i>${opt.text}`
        : opt.stockName
        ? `$${opt.stockName}(${opt.id
            .substring(0, 2)
            .toUpperCase()}${opt.id.substring(2)})$`
        : opt.name
        ? `$${opt.name}(${opt.portfolioCode})$`
        : `@${opt.username}`;
      // 区分组合和股票
      const mark = opt && opt.portfolioCode ? 'portfolio' : this.searchType;
      newDom.setAttribute('selected-n', mark);
      // @用户 添加id
      if (this.searchType === 'user') {
        newDom.setAttribute('id', 'user-' + opt.userId);
      }
      // 链接 可点击
      if (opt.url) {
        newDom.setAttribute(
          'href',
          !opt.url.includes('http') ? 'https://' + opt.url : opt.url
        );
        newDom.setAttribute('target', '_blank');
      }
      parentDom.replaceChild(newDom, holdDom);
      newDom.outerHTML = newDom.outerHTML + '&nbsp;';
      this.changeCanConfirm();
    },
    /**
     * @description 取消评论
     */
    cancelComment() {
      this.$emit('cancel');
    },
    /**
     * @description 发表评论
     */
    sendComment() {
      const now = new Date().getTime;
      if (this.sendTime && this.sendTime - now > 1000) return;
      this.sendTime = now;
      if (!this.isLogin) {
        this.show(false);
        return;
      }
      if (this.closeComment) {
        this.messageData.show = true;
        this.messageData.content = '该内容已限制评论';
        return;
      }
      const contentBox = document.querySelector(`.input-box${this.className}`);
      const contentBoxClone = contentBox.cloneNode(true);
      const contentNodes = contentBoxClone.childNodes;
      const nodeLength = contentNodes.length || 0;
      const pictureUrls = this.picList.map(picitem => {
        return picitem.imgurl;
      });
      // 选中的股票、用户、组合
      const refContents = {
        stock: [],
        portfolio: [],
        user: [],
      };
      for (let i = 0; i < nodeLength; i++) {
        const cnode = contentNodes[i];
        const { nodeType, nodeName } = cnode;
        if (nodeType === 1 && nodeName && nodeName.toLowerCase() === 'a') {
          let userId = '';
          let stock = '';
          let portfolio = '';
          const type = cnode.getAttribute('selected-n');
          switch (type) {
            case 'link':
              // 链接
              cnode.innerText = ` <[[${
                cnode.lastChild && cnode.lastChild.nodeValue
              }](${cnode.href})]>`;
              break;
            case 'user':
              // 用户
              userId = cnode.id.split('user-')[1];
              cnode.innerText = ` <[${cnode.innerText.trim()},${userId}]>`;
              if (!refContents.user.includes(userId)) {
                refContents.user.push(userId);
              }
              break;
            case 'stock':
              // 股票
              cnode.innerText = ` <[${cnode.innerText}]>`;
              stock = cnode.innerText.match(/\(([\s\S]*)\)/)[1];
              if (!refContents.stock.includes(stock)) {
                refContents.stock.push(stock);
              }
              break;
            case 'portfolio':
              // 组合
              cnode.innerText = ` <[%${cnode.innerText.substring(
                1,
                cnode.innerText.length - 1
              )}%]>`;
              portfolio = cnode.innerText.match(/\(([\s\S]*)\)/)[1];
              if (!refContents.portfolio.includes(portfolio)) {
                refContents.portfolio.push(portfolio);
              }
              break;
            default:
              break;
          }
        }
      }
      const files = this.fileUploadedArray || [];
      let htmlContent = contentBoxClone.innerHTML
        ? sanitizeHtml(contentBoxClone.innerHTML, {
            allowedTags: [],
            allowedAttributes: {},
          })
        : '';
      htmlContent = htmlContent
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&nbsp;/gi, ' ');
      const content = htmlContent
        ? htmlContent
        : files.length > 0
        ? '分享文件'
        : '';
      const momentTags = (this.confirmedMomentTags || []).map(
        item => item.tagId
      );
      const momentId = this.momentId ? this.momentId : undefined;
      const questionType =
        this.questionAnonymity === true ? 'anonymity' : 'public';
      this.$emit('confirm', {
        topic: this.topic,
        replyId: this.replyId,
        replyCommentId: this.replyCommentId,
        title: this.dynamicTitle,
        content,
        momentTags,
        files,
        pictureUrls,
        shareObj: this.shareObj,
        refContents,
        retweet: this.isCheck,
        momentId,
        questionType,
      });
      this.dynamicTitle = null;
      this.picList = [];
      this.confirmedMomentTags = [];
      this.fileUploadedArray = [];
      this.topic = {};
      this.changeCanConfirm();
      this.showDefaultContent();
    },
    /**
     * @description 改变发表按钮状态
     */
    changeCanConfirm() {
      const now = new Date().getTime;
      if (this.inputTime && this.inputTime - now > 500) {
        return;
      }
      this.inputTime = now;
      let contentText = '';
      const contentBox = document.querySelector(`.input-box${this.className}`);
      contentText = contentBox ? contentBox.innerText.trim() : '';
      this.canConfirm = !!(
        contentText ||
        this.fileUploadedArray.length ||
        this.picList.length ||
        this.shareObj
      );
    },

    /**
     * @description 鼠标击输入框
     */
    clickInput(e) {
      if (!this.isLogin) {
        // 未登录时
        this.show(false);
        return false;
      }
      if (this.reviewStatus !== 'approved') {
        this.messageData = {
          show: true,
          content: '内容正在审核中',
        };
        return false;
      }
      if (this.closeComment) {
        this.messageData.show = true;
        this.messageData.content = '该内容已限制评论';
      }
      if (!this.contenteditable) {
        return false;
      }
      this.previewImageHandle(e);
      // 展开输入框
      this.collapse = false;
    },
    /**
     * @description 查看图片
     * @param {*} e
     */
    previewImageHandle(e) {
      if (
        e.target.getAttribute('image-url') ||
        e.target.parentNode.getAttribute('image-url')
      ) {
        this.previewSrcList = [
          e.target.getAttribute('image-url') ||
            e.target.parentNode.getAttribute('image-url'),
        ];
        this.showViewer = true;
      }
    },
    handlePublishPost() {
      if (!this.isLogin) {
        // 未登录时
        this.show(false);
        return;
      }
      window.open('/articleCreate/norpub.html');
    },
    // 选中标签
    handleTagItem(tag) {
      const index = this.momentTags.findIndex(item => item.tagId === tag.tagId);
      if (index === -1) {
        this.momentTags.push(tag);
      } else {
        this.momentTags.splice(index, 1);
      }
    },
    // 点击确定标签
    confirmTagBTN() {
      this.showTagChoose = false;
      this.confirmedMomentTags = [...this.momentTags];
    },
    // 点击选中标签文本
    async handleTagText() {
      await this.initAvailableTags();
      this.showTagChoose = !this.showTagChoose;
      this.confirmedMomentTags = [];
    },
    // 点击标签初始化可用标签
    async initAvailableTags() {
      const momentId = this.momentId;
      const data = await this.$axios(GetAvailableTags(momentId));
      const r = data?.result || [];
      this.optionalTags = r.filter(item => item.isDefault === false);
      this.defaultTags = r.filter(item => item.isDefault === true);
    },
    onFileDrop(e) {
      if (!this.isLogin) {
        this.show(false);
        return;
      }
      this.dragover = false;
      if (this.uploading) return false;
      this.handleUpload(e.dataTransfer.files);
    },
    handlePaste(e) {
      if (!this.isLogin) {
        this.show(false);
        return;
      } else if (!this.isPasteUpload) {
        return false;
      }
      const clipboardData = window.clipboardData || e.clipboardData;
      const { files } = clipboardData;
      if (!files || files.length === 0) {
        return false;
      }
      e.preventDefault();
      this.handleUpload(files);
    },
    async handleUpload(files) {
      const arr = [].slice.call(files);
      const imgArr = arr.filter(file => {
        const { type } = file;
        return type.indexOf('image') === 0;
      });
      if (arr.length === imgArr.length) {
        if (this.picList.length + arr.length > this.imageLimit) {
          this.messageData.show = true;
          this.messageData.content = `不能超过${this.imageLimit}张图片`;
          return false;
        } else if (
          (this.avalibleExtroType && this.avalibleExtroType !== 'img') ||
          this.fileUploadedArray.length > 0
        ) {
          this.messageData.show = true;
          this.messageData.content = '不能同时上传图片和文件';
          return false;
        }
        for (const file of arr) {
          const res = await this.uploadImg(file);
          if (res === false) return false;
        }
      } else if (imgArr.length === 0) {
        const Count = this.fileUploadedArray.length + arr.length;
        if (Count > 10) {
          this.messageData.show = true;
          this.messageData.content = '上传数量限制10个';
        } else if (
          (this.avalibleExtroType && this.avalibleExtroType !== 'file') ||
          this.picList.length > 0
        ) {
          this.messageData.show = true;
          this.messageData.content = '不能同时上传图片和文件';
          return false;
        }
        this.upload(arr);
      } else {
        this.messageData.show = true;
        this.messageData.content = '不能同时上传图片和文件';
        return false;
      }
    },
    onDragover() {
      if (!this.isDropUpload) return false;
      this.dragover = true;
    },
    handleDragleave() {
      this.dragover = false;
    },
    focusInput() {
      const inputRef = this.$refs.commentInput;
      if (inputRef) {
        inputRef.focus();
        inputRef.click();
      }
    },
  },
};
